import { apiSlice } from '../../../app/api/apiSlice'
import { type AuthAdmin } from '../types/auth.types'
interface ILoginParam {
  email: string
  password: string
}
export const extendApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<Promise<AuthAdmin>, ILoginParam>({
      query: (loginparam: ILoginParam) => ({
        url: '/authadmin/login',
        credentials: 'include',
        method: 'POST',
        body: {
          ...loginparam
        }
      }),
      transformResponse: (response: AuthAdmin) => {
        if (response.adminLevel === 'USER') {
          throw new Error('Insufficient privileges: User level not allowed');
        }
        return Promise.resolve(response);
      }
    }),
  })
 
})

export const { useLoginMutation } = extendApiSlice
